import React from 'react'

import { Content } from 'antd/es/layout/layout'
import PAQ from '../shop-front-component/PAQ'

import { useNavigate } from 'react-router-dom'
import { Breadcrumb, Image } from 'antd'
import { CategoryRoute, ProductCardType, blindList, toBlind } from '../shop-front-component/ProductCollection'

export default function GenericProductPage(data:ProductCardType|undefined, categoryRoute: CategoryRoute) {
    const navigate = useNavigate()
  return (
      <div className='hedvig-letters-sans-regular bg-white m-1'>
      
            <Content className=' bg-transparent'>
                <div className='max-w-screen-2xl flex flex-row m-auto mt-10 justify-between p-2'>
                    <Breadcrumb
                        items={[
                        {
                            title: <span onClick={()=>{navigate('/')}} className=' hover:underline hover:-translate-y-1 duration-300 transition-transform '>Home</span>,
                        },
                        {
                            title: <span onClick={()=>{navigate('/product-list',{state:categoryRoute})}} className=' hover:underline hover:-translate-y-1 duration-300 transition-transform '>{categoryRoute.title}</span>,
                        },
                        {
                            title: data?.name,
                        },
                        ]}
                    />
                </div>
                <div className='max-w-screen-2xl flex flex-col lg:flex-row m-auto justify-between gap-5 mt-5'>
                    <div className='w:full lg:w-2/3'>
                        
                        <div className='w-full flex justify-center aspect-video overflow-hidden shadow-md  border-none bg-white rounded-lg mx-auto overflow-hidden' >
                                                <Image
                                                    src={data?.cover}    
                                                    alt="Centered Image"
                                                    height={"100%"}
                                              
                                                    className="transform object-cover object-center"
                                                /> 
                                                
                                </div>
                    </div>
                    <div className=' w:full lg:w-1/3 aspect-square flex flex-col '>
                        <span className='hedvig-letters-serif-regular text-6xl '>
                            {data?.name}
                        </span>
                        <span className='hedvig-letters-sans-regular text-xl text-neutral-700 mt-5 '>
                            From ${data?.start}
                        </span>
                        <span className='hedvig-letters-sans-regular text-lg text-neutral-500 mt-5 '>
                            {data?.description}
                        </span>
                        
                        <button className="transform text-white bg-black text-xl lg:text-2xl rounded-md border-solid border-black hover:text-black hover:bg-white transition-transform duration-300 w-fit p-2 px-5 hover:translate-x-1 mb-5 mt-20"
                            onClick={()=>{navigate('/order/create')}}
                        >Order Online Now</button>
                    </div>
                </div>
                
                <div className='flex flex-col max-w-screen-2xl m-auto items-center justify-center mt-20 mb-32'>
                    <span className='text-2xl lg:text-5xl text-center hedvig-letters-serif-regular'>
                        Need help from our expert?
                    </span>
                    <span className='text-2xl text-center hedvig-letters-sans-regular underline transition-all duration-300 hover:translate-x-1 hover:text-neutral-500 mt-3'
                        onClick={()=>{navigate('/contact')}}
                    >
                        Contact us
                    </span>
                    
                </div>
            </Content>

        </div>
  )
}
